// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2508":"a6e6425876428eb29d6c","4827":"e613c7cd214863780c37"}[chunkId] + ".css";
};